/* DRIVE IQ — ADVENTURE MODE V600 EVENTS
   File: adventure-events.js
*/
(function(window){
"use strict";

if(window.DriveIQAdventureEvents){return;}

var listeners={};
var anyListeners=[];

function on(name,handler){
  if(typeof handler!=="function"){throw new Error("Event handler required");}
  name=String(name||"");
  (listeners[name]||(listeners[name]=[])).push(handler);
  return function(){off(name,handler);};
}

function once(name,handler){
  var unsub=on(name,function(payload){
    unsub();
    handler(payload);
  });
  return unsub;
}

function off(name,handler){
  var list=listeners[String(name||"")];
  if(!list){return;}
  var i=list.indexOf(handler);
  if(i>=0){list.splice(i,1);}
}

function onAny(handler){
  if(typeof handler!=="function"){throw new Error("Handler required");}
  anyListeners.push(handler);
  return function(){
    var i=anyListeners.indexOf(handler);
    if(i>=0){anyListeners.splice(i,1);}
  };
}

function emit(name,payload){
  name=String(name||"");
  var event={
    name:name,
    payload:payload,
    timestamp:Date.now()
  };
  var list=(listeners[name]||[]).slice();
  for(var i=0;i<list.length;i++){
    try{list[i](event);}catch(e){console.error("[Adventure Events]",name,e);}
  }
  var all=anyListeners.slice();
  for(i=0;i<all.length;i++){
    try{all[i](event);}catch(e2){console.error("[Adventure Events]",name,e2);}
  }
  return event;
}

function clear(name){
  if(name==null){
    listeners={};
    anyListeners=[];
    return;
  }
  delete listeners[String(name)];
}

window.DriveIQAdventureEvents={
  on:on,
  once:once,
  off:off,
  onAny:onAny,
  emit:emit,
  clear:clear
};

console.log("[Drive IQ Adventure V600] Events loaded");
})(window);
